var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    [
      _c("LoginTextField", {
        attrs: {
          autocomplete: false,
          autoFocus: "",
          label: _vm.label,
          maxlength: 6,
          placeholder: _vm.placeholder,
          required: "",
          submitOnEnter: _vm.handleSubmit,
          value: _vm.token,
          vvName: "verification code",
        },
        on: { input: _vm.handleInput },
      }),
      _vm._v(" "),
      _c(
        "LoginActionButton",
        {
          attrs: {
            action: _vm.handleSubmit,
            disabled: _vm.isDisabled,
            isLoading: _vm.isLoading,
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.buttonText) + "\n  ")]
      ),
      _vm._v(" "),
      _vm.shouldShowTOTPResetLink
        ? _c(
            "div",
            { class: _vm.$style.resetPassword },
            [
              _c(
                "span",
                {
                  class:
                    ((_obj = {}),
                    (_obj[_vm.$style.resetPasswordLink] = true),
                    (_obj[_vm.$style.fadeTransition] = true),
                    (_obj[_vm.$style.fadeTo] = _vm.isLoadingReset),
                    _obj),
                  on: { click: _vm.handleResetTOTP },
                },
                [_vm._v("\n      Lost your TOTP device?\n    ")]
              ),
              _vm._v(" "),
              _c(
                "transition",
                {
                  attrs: {
                    enterClass: _vm.$style.fadeTo,
                    enterActiveClass: _vm.$style.fadeTransition,
                    leaveActiveClass: _vm.$style.fadeTransition,
                    leaveToClass: _vm.$style.fadeTo,
                  },
                },
                [
                  _vm.isLoadingReset
                    ? _c(
                        "div",
                        { class: _vm.$style.loadingIconContainer },
                        [_c("LoadingIcon")],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }